module.exports = __webpack_public_path__ + "img/solarstand.aa42f645.svg";